import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './ui/Sidebar';
import Header from './ui/Header';
import { cn } from '../utils/cn';

const Layout = ({ children }) => {
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <div className="h-screen overflow-hidden bg-transparent flex">
      {/* Sidebar */}
      <Sidebar 
        isMobileOpen={isMobileOpen} 
        setIsMobileOpen={setIsMobileOpen}
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
      />

      {/* Main Content */}
      <div 
        className={cn(
          "flex-1 flex flex-col min-w-0 transition-all duration-300 ease-in-out",
          isCollapsed ? "lg:pl-16" : "lg:pl-64"
        )}
      >
        <Header onMenuClick={() => setIsMobileOpen(true)} />
        
        <main className="flex-1 p-4 sm:p-6 lg:p-6 overflow-y-auto flex flex-col min-h-0">
          <div className="max-w-[2400px] mx-auto w-full flex-1 animate-fade-in">
            {children || <Outlet />}
          </div>
        </main>

        <footer className="py-4 px-8 border-t border-cos-line-subtle text-center text-xs text-cos-ink-muted">
           &copy; {new Date().getFullYear()} ASOS. All rights reserved.
        </footer>
      </div>
    </div>
  );
};

export default Layout;
